/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ExitInputs */

const en_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit`)
};

const fr_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitter`)
};

const de_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausfahrt`)
};

const it_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscita`)
};

const ru_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выход`)
};

const es_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida`)
};

const zh_cn2_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const hi_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाहर निकलना`)
};

const pt_pt2_exit = /** @type {(inputs: ExitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída`)
};

/**
* | output |
* | --- |
* | "Exit" |
*
* @param {ExitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exit = /** @type {((inputs?: ExitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ExitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_exit(inputs)
	if (locale === "de") return de_exit(inputs)
	if (locale === "it") return it_exit(inputs)
	if (locale === "ru") return ru_exit(inputs)
	if (locale === "es") return es_exit(inputs)
	if (locale === "zh-CN") return zh_cn2_exit(inputs)
	if (locale === "ja") return ja_exit(inputs)
	if (locale === "hi") return hi_exit(inputs)
	if (locale === "pt-PT") return pt_pt2_exit(inputs)
	return en_exit(inputs)
});